<template>
  <main>
  </main>
</template>

<script>
import {forEach, times, constant, sample, get, lowerCase} from 'lodash'
import CommonMixin from '@/mixins/CommonMixin'
import DirectStoreAccessMixin from '@/mixins/DirectStoreAccessMixin'
export default {
  name: 'FKMODconnectCall',
  mixins: [ CommonMixin, DirectStoreAccessMixin ],
  methods: {
    makeRandStr: function (len) { // ランダム文字列生成処理
      let result = ''
      forEach(times(len, constant(0)), () => {
        result += sample('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789')
      })
      return result
    }
  },

  // onload
  beforeMount () {
    this.setDirectStoreCode(get(window, 'miniappparam', ''))
    const self = this
    // 任意の文字列（ここではランダム）＋ミニアプリID
    const hashkey = this.makeRandStr(16)
    // 遷移元確認インタフェース結果取得処理[callback]
    window.receiveVerifyHash = (hashValue) => {
      // バックエンドAPIからハッシュ値取得
      self.callApi('DcmGetHash',
        {
          base_string: hashkey
        }
      ).then((res) => {
        // ハッシュ値チェック処理
        if (lowerCase(hashValue) === lowerCase(get(res, 'data.value.hash_value', ''))) {
          // チェックOKならdアカウントコネクト認証開始API呼び出し
          window.location.href = self.getApiUrl('DcmAuthStart')
        } else {
          // チェック失敗
          this.moveToError('ERR_703')
        }
      })
    }

    // 遷移元確認インタフェース処理依頼
    if (/jp.kp.sp.sdk.ios_/i.test(navigator.userAgent) &&
        get(window, 'webkit.messageHandlers.verification.postMessage', false)) {
      // iOS端末
      this.$store.dispatch('setDPayiOS')
      // 遷移元確認IFコール
      window.webkit.messageHandlers.verification.postMessage(hashkey)
    } else if (/jp.kp.sp.sdk.and_/i.test(navigator.userAgent) &&
                get(window, 'android.verification', false)) {
      // Android端末
      this.$store.dispatch('setDPayAndroid')
      // 遷移元確認IFコール
      /* eslint no-undef: 0 */
      android.verification(hashkey)
    } else {
      // 想定外のUA端末、
      this.moveToError('ERR_702')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DconnectCall.vue